import Axios from 'axios';
import request from './request.js';
let configURL = {}
const NODE_ENV = process.env.NODE_ENV; // dev:开发环境 | test:测试环境
console.log(NODE_ENV, "NODE_ENV");
if (NODE_ENV === "development") {
  //本地环境
  console.log('本地环境');
  console.log(NODE_ENV, "NODE_ENV")
  configURL = {
    userURL: 'https://user11.sungivenplus.com/api/',
    storeURL: 'https://store11.sungivenplus.com/api/'
  }
} else if (NODE_ENV === 'test') {
  //测试环境
  console.log('测试环境');
  console.log(NODE_ENV, "NODE_ENV")
  configURL = {
    userURL: 'https://user11.sungivenplus.com/api/',
    storeURL: 'https://store11.sungivenplus.com/api/'
  }
} else if (NODE_ENV === 'production') {
  //生产环境
  console.log('生产环境')
  configURL = {
    userURL: 'https://user.sungivenfoods.ca/api/',
    storeURL: 'https://store.sungivenfoods.ca/api/'
  }
}
var headers = {
  'sso': window.localStorage.getItem('sso') || '',
  'content-type': 'application/json;charset=UTF-8'
}
export default {
  configURL,
  //获取广告位
  getStoreAdvert(param) {
    return request.post_json(configURL.storeURL + "advert/getstoreadvert/", param);
  },
  //获取轮播
  getIndexSwiperBanner(param) {
    return request.post_json(configURL.storeURL + "advert/getfirstpopbanner/", param);
  },
  //獲取門店廣告位
  getIndexStoreBanner(param) {
    return request.post_json(configURL.storeURL + "advert/getbanner/", param);
  },
  //手機號登錄
  loginByMobile(params) {
    return request.post_json(configURL.userURL + "member/bind/", param);
  },
  //獲取手機驗證碼
  getLoginCheckCode(param) {
    return request.post_json(configURL.userURL + "member/getbindcode/", param);
  },
  //獲取用戶信息
  getUserDetail() {
    return request.post_json(configURL.userURL + "my/getinfo", )
  },
  //获取用户缓存邮箱列表
  getUserEmailList() {
    return request.post_json(configURL.storeURL + "ticket/getEmailList", )
  },
  //发送邮箱验证码
  sendEmailVerify(param) {
    return request.post_json(configURL.storeURL + "common/sendemailverify", param)
  },
  //发送绑卡验证码
  sendCardVerifybind(param) {
    return request.post_json(configURL.userURL + "card/verifybind", param)
  },
  //绑定实体礼卡的接口请求
  bindAnonymityCard(param) {
    return request.post_json(configURL.userURL + "card/bindAnonymity", param)
  },
  // 绑定电子卡卷的接口请求
  binCard(param) {
    return request.post_json(configURL.userURL + "card/bind", param)
  },
  // 获取缴费记录
  flowCard(param) {
    return request.post_json(configURL.userURL + "card/flow", param)
  },
  //获取卡片的接口
  getCardVoucherList() {
    return request.post_json(configURL.userURL + "cardVoucher/list", )
  },
  //首页新人礼的接口请求
  getNewUserInfo(param) {
    return request.post_json(configURL.storeURL + "newuser/info", param)
  },
  //领取红包的接口
  sendCouponRedpacket(param) {
    return request.post_json(configURL.storeURL + "redpacket/sendcoupon", param)
  },
  //关闭领取红包的接口
  closeRedpacket(param) {
    return request.post_json(configURL.storeURL + "redpacket/close", param)
  },
  // 红包展示请求接口
  getRedPacketInfo(param) {
    return request.post_json(configURL.storeURL + "redpacket/coupon", param)
  },
  //首页领取新人礼
  getNewUserReceive(param) {
    return request.post_json(configURL.storeURL + "newuser/receive", param)
  },
  //个人信息页保存邮箱
  saveEmail(param) {
    return request.post_json(configURL.storeURL + "common/saveemail", param)
  },
  //补发小票
  sendTick(param) {
    return request.post_json(configURL.storeURL + "ticket/sendtick/", param)
  },
  //修改用戶信息
  updateUserDetail(param) {
    return request.post_json(configURL.userURL + "my/updateinfo", param)
  },
  //获取地址列表
  getUserAddressList() {
    return request.post_json(configURL.storeURL + "address/list/", '');
  },
  //删除地址
  deleteAddr(param) {
    return request.post_json(configURL.storeURL + "address/delete/", param);
  },
  //微信授权登录
  loginByWechat(param) {
    return request.post_json(configURL.userURL + "wxprogram/login", param);
  },
  //重置密码
  resetPassword(param) {
    return request.post_json(configURL.userURL + "Wxprogram/password", param);
  },
  // 獲取門店列表
  getStoreLists(param) {
    return request.post_json(configURL.storeURL + "store/search/", param);
  },
  // 新獲取門店列表
  getStoreSearchLists(param) {
    return request.post_json(configURL.storeURL + "store/searchlist/", param);
  },
  //获取上次支付方式的接口
  getCurrencypaytype() {
    return request.post_json(configURL.storeURL + "order/getcurrencypaytype");
  },
  // 获取门店列表
  getOfflinesLists(param) {
    return request.post_json(configURL.storeURL + "offlinestore/lists/", param);
  },
  // 获取门店首页商品列表
  getStoreTotalInfo(param) {
    return request.post_json(configURL.storeURL + "store/index/", param);
  },
  // 获取门店分类商品
  getProductList(param) {
    return request.post_json(configURL.storeURL + "store/categorygoods/", param);
  },
  // 获取购物车数量
  getCartNum(param) {
    return request.post_json(configURL.storeURL + "cart/goodsnum", param);
  },
  // 添加购物车数量
  addGoods(param) {
    return request.post_json(configURL.storeURL + "cart/addgoods/", param);
  },
  // 减少购物车数量
  decreaseGoods(param) {
    return request.post_json(configURL.storeURL + "cart/decrease/", param);
  },
  //手动修改商品数量
  updateGoodsNum(param) {
    return request.post_json(configURL.storeURL + "cart/updatedetail/", param);
  },
  // 獲取購物車數據
  getCart(param) {
    return request.post_json(configURL.storeURL + "cart/index/", param);
  },
  // 操作购物车商品
  selectGoods(param) {
    return request.post_json(configURL.storeURL + "cart/select/", param);
  },
  // 結算商品
  checkOrder(param) {
    return request.post_json(configURL.storeURL + "cart/check/", param);
  },
  // 獲取訂單列表
  getOrderList(param) {
    return request.post_json(configURL.storeURL + "order/lists/", param);
  },
  //获取登录信息
  authLogin() {
    return request.post_json(configURL.userURL + "Wxprogram/autologin/", '');
  },
  //获取分城市地址列表
  getAddressLists(param) {
    return request.post_json(configURL.storeURL + 'address/listforcity/', param);
  },
  //搜索地理位置
  searchPlacePoi(param) {
    return request.post_json(configURL.storeURL + 'address/getplacepoi', param);
  },
  //添加地址
  addAddr(param) {
    return request.post_json(configURL.storeURL + 'address/add/', param);
  },
  //修改地址
  updateAddr(param) {
    return request.post_json(configURL.storeURL + 'address/update/', param);
  },
  //整店刪除購物車商品
  deleteGoods(param) {
    return request.post_json(configURL.storeURL + 'cart/deletegoods/', param);
  },
  //减少購物車商品-购物车
  addGoodsByCart(param) {
    return request.post_json(configURL.storeURL + 'cart/increase/', param);
  },
  //刪除購物車商品
  decreaseGoodsByCart(param) {
    return request.post_json(configURL.storeURL + 'cart/decrease/', param);
  },
  //獲取用戶信息
  getUserInfo() {
    return request.post_json(configURL.userURL + 'Wxprogram/getuser/', '');
  },
  //註冊
  register(param) {
    return request.post_json(configURL.userURL + 'Wxprogram/register/', param);
  },
  //登錄
  login(param) {
    return request.post_json(configURL.userURL + 'Wxprogram/logins/', param);
  },
  //獲取地址列表
  // getAddressInfo(id) {
  //   return request.post_json(configURL.userURL + 'address/list/', param);
  // },
  // 下單
  addOrder(param) {
    return request.post_json(configURL.storeURL + 'order/add/', param);
  },
  //支付
  pay(param) {
    return request.post_json(configURL.storeURL + "order/pay/", param)
  },
  //獲取訂單詳情
  getOrdeDetail(param) {
    return request.post_json(configURL.storeURL + "order/detail/", param)
  },
  //取消訂單
  cancelOrder(param) {
    return request.post_json(configURL.storeURL + "order/cancel/", param)
  },
  //支付回調
  // payRespond(param){
  //   return request.post_json(configURL.storeURL + "order/payrespond/", param)
  // },
  //支付回調get
  // payRespondget(param){
  //   return request.get_json(configURL.storeURL + "order/payrespond/", param)
  // },
  //支付方式列表
  getPayWayList(param) {
    return request.post_json(configURL.storeURL + "bank/list/", param)
  },
  //再來一單
  getOrderAgain(param) {
    return request.post_json(configURL.storeURL + "order/again/", param)
  },
  //订单详情
  getOrderDetail(param) {
    return request.post_json(configURL.storeURL + "order/detail/", param)
  },
  //申请售后
  orderRefund(param) {
    return request.post_json(configURL.storeURL + "refund/add/", param)
  },
  //售后详情
  getRefundDetail(param) {
    return request.post_json(configURL.storeURL + "refund/detail/", param)
  },
  //删除订单
  deleteOrder(param) {
    return request.post_json(configURL.storeURL + "order/delete/", param)
  },
  //校验地址
  checkAddress(param) {
    return request.post_json(configURL.storeURL + "cart/chgaddress", param)
  },
  //获取二维码
  getQrCode(code) {
    request.post_json(configURL.storeURL + "order/qrcode/code/" + code, '')
  },
  //獲取商品詳情
  getGoodsDetail(param) {
    return request.post_json(configURL.storeURL + "goods/detail/", param)
  },
  //搜索商品
  searchProduct(param) {
    return request.post_json(configURL.storeURL + "store/goodssearch", param)
  },
  //獲取優惠券
  getUserCoupons(param) {
    return request.post_json(configURL.storeURL + "coupon/couponloglist/", param)
  },
  //获取专栏
  getSpecialColums(param) {
    return request.post_json(configURL.storeURL + "topic/indexconfig/", param);
  },
  //获取专栏详情
  getSpecialColumsDetail(param) {
    return request.post_json(configURL.storeURL + "topic/index/", param);
  },
  //获取渠道配置信息
  getScenedecode(param) {
    return request.post_json(configURL.storeURL + "common/scenedecode", param);
  },
  //获取渠道红包
  getRedpacketCoupon(param) {
    return request.post_json(configURL.storeURL + "channelredpacket/coupon", param);
  },
  //领取渠道红包接口
  sendRedpacketCoupon(param) {
    return request.post_json(configURL.storeURL + "channelredpacket/sendcoupon", param);
  },

  //兑换优惠券
  exchangeCouponByCode(param) {
    return request.post_json(configURL.storeURL + "coupon/exchangecouponcode", param);
  },
  // 領券
  getCoupon(param) {
    return request.post_json(configURL.storeURL + "voucher/qzsendcoupon/", param);
  },
  //是否彈窗
  isShowPop(param) {
    return request.post_json(configURL.userURL + "user/isshow", param);
  },
  //添加信用卡
  addCard(param) {
    return request.post_json(configURL.storeURL + "CreditCard/AddCard", param);
  },
  //添加成后保存信用卡
  saveCard(param) {
    return request.post_json(configURL.userURL + "CreditCard/queryCard", param);
  },
  //信用卡列表
  getCardList() {
    return request.post_json(configURL.storeURL + "CreditCard/creditCardList");
  },
  //支付列表
  getPayList() {
    return request.post_json(configURL.storeURL + "CreditCard/currentPayList");
  },
  //删除信用卡
  delCard(param) {
    return request.post_json(configURL.storeURL + "CreditCard/delCard", param);
  },
  //上传头像
  upLoadPhoto(param) {
    return request.post_json(configURL.storeURL + "upload/single", param);
  },
  //定位失败获取门店列表
  locationFailGetStoreList(param) {
    return request.post_json(configURL.storeURL + "store/list", param);
  },
  //获取国家列表
  getAreaList() {
    return request.post_json(configURL.storeURL + "country/getlist");
  },
  //推薦分類
  getRecommondList(param) {
    return request.post_json(configURL.storeURL + "store/getrecommendgoods", param);
  },
  //线上购物说明
  getShopingDirectory() {
    return request.post_json(configURL.storeURL + "shopping/directory");
  },
  //线下门店详情
  getOffStoreDetail(param) {
    return request.post_json(configURL.storeURL + "offlinestore/info", param);
  },
  //PC支付回调
  getPCData(param) {
    return request.post_json(configURL.storeURL + "CreditCard/query", param);
  },
  //註冊時添加郵箱
  addEmail(param) {
    return request.post_json(configURL.userURL + "user/addemail", param);
  },
  //注销账号
  cancelAccount(param) {
    return request.post_json(configURL.userURL + "user/cancel", param);
  },
  //注销提示内容
  getCancelInfo(param) {
    return request.post_json(configURL.userURL + "member/cancelinfo", param);
  },
  //分享商品详情
  getShareDetail(param) {
    return request.post_json(configURL.storeURL + "groupon/goodsdetail", param);
  },
  //分享商品详情
  getShareGrouponDetail(param) {
    return request.post_json(configURL.storeURL + "groupon/detail", param);
  }

}



// WEBPACK FOOTER //
// ./src/service.js